<div class="auth">
  <div class="auth__glow" aria-hidden="true"></div>

  <header class="auth__top">
    <a routerLink="/" class="auth-brand" aria-label="PulseWatch home">
      <span class="auth-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="auth-brand__name">PulseWatch</span>
    </a>
    <a routerLink="/knowledge-base" class="auth__help">Help</a>
  </header>

  <main class="auth__main">
    <!-- Brand side (desktop only) -->
    <section class="auth__showcase" aria-hidden="true">
      <div class="auth__globe"><app-pulse-globe></app-pulse-globe></div>
      <h2>Everything's watched.<br /><span class="auth-gradient">Sleep well.</span></h2>
      <p>Uptime checks, status pages, errors and traces for all your projects, in one place.</p>
    </section>

    <!-- Login card -->
    <section class="auth-card">
      <h1>Welcome back</h1>
      <p class="auth-card__sub">Log in to your PulseWatch account.</p>

      <form [formGroup]="form" (ngSubmit)="login()" novalidate>
        <label class="auth-field">
          <span>Email</span>
          <div class="auth-field__box" [class.is-invalid]="invalid('username')">
            <i class="bx bx-envelope" aria-hidden="true"></i>
            <input type="email" formControlName="username" placeholder="you@company.com" autocomplete="username" inputmode="email" />
          </div>
          @if (invalid('username')) {
            <small class="auth-field__error">Please enter a valid email address.</small>
          }
        </label>

        <label class="auth-field">
          <span class="auth-field__row">
            Password
            <a routerLink="/forgot-password" class="auth-link">Forgot password?</a>
          </span>
          <div class="auth-field__box" [class.is-invalid]="invalid('password')">
            <i class="bx bx-lock-alt" aria-hidden="true"></i>
            <input
              [type]="showPassword() ? 'text' : 'password'"
              formControlName="password"
              placeholder="Your password"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="auth-field__toggle"
              (click)="showPassword.set(!showPassword())"
              [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
            >
              <i class="bx" [class.bx-show]="!showPassword()" [class.bx-hide]="showPassword()"></i>
            </button>
          </div>
          @if (invalid('password')) {
            <small class="auth-field__error">Please enter your password.</small>
          }
        </label>

        @if (loginError()) {
          <div class="auth-alert" role="alert"><i class="bx bx-error-circle"></i>{{ loginError() }}</div>
        }

        <button type="submit" class="auth-btn" [disabled]="isLoading()">
          @if (isLoading()) {
            <span class="auth-btn__spinner" aria-hidden="true"></span> Logging in…
          } @else {
            Log in <i class="bx bx-right-arrow-alt"></i>
          }
        </button>
      </form>

      @if (requestAccessProject) {
        <div class="login-access" data-testid="login-request-access">
          <i class="bx bx-lock-open-alt" aria-hidden="true"></i>
          <p>
            Someone shared a PulseWatch link with you but you don’t have an account in their team?
            <a routerLink="/request-access" [queryParams]="{ next: returnPath }" class="auth-link">Request access</a>
          </p>
        </div>
      } @else {
        <p class="auth-card__alt">New to PulseWatch? <a routerLink="/register" class="auth-link">Create an account</a></p>
      }
    </section>
  </main>

  <footer class="auth__footer">{{ versions.hash }} · {{ versions.date | date: 'short' }}</footer>
</div>
